var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9936 44.126H22.9602C12.6116 44.126 3.93024 36.6991 2.31885 26.5123C2.22407 25.9045 1.64977 25.4864 1.04201 25.5811C0.43426 25.6759 0.0160811 26.2502 0.116444 26.858C1.8951 38.1321 11.5021 46.3507 22.9546 46.3507H22.9936C29.4503 46.3507 35.6561 43.7468 40.0219 39.2082C44.1758 34.887 46.328 29.1942 46.0827 23.178C45.553 10.2368 35.3996 0.100098 22.9602 0.100098C14.4628 0.100098 6.62889 4.86734 2.63109 12.2106V1.75051C2.63109 1.13718 2.12928 0.635367 1.51595 0.635367C0.902621 0.635367 0.400806 1.13161 0.400806 1.75051V15.6898C0.400806 16.3031 0.902621 16.805 1.51595 16.805H15.4553C16.0686 16.805 16.5704 16.3031 16.5704 15.6898C16.5704 15.0765 16.0686 14.5747 15.4553 14.5747H3.94696C7.30912 7.20357 14.7973 2.33039 22.9602 2.33039C34.1953 2.33039 43.3729 11.5303 43.858 23.2728C44.081 28.6757 42.1462 33.7886 38.4216 37.6693C34.474 41.773 28.8537 44.1316 22.9992 44.1316L22.9936 44.126Z",
    fill: "#FF669B",
    stroke: "#FF669B",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.31daecdaedbd3aaa5d5efe9145d311c9.svg";
export { ForwardRef as ReactComponent };